import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Contract} from '../../model/Entities/Contract';
import {ContractItem} from '../../model/Entities/ContractItem';
import {AvailabilityContract} from '../../model/Entities/Availability';

@Component({
    selector: 'contract-item-availability-dialog',
    templateUrl: './contract-item-availability.dialog.component.html',
    styleUrls: ['./contract-item-availability.dialog.component.scss']
})
export class ContractItemAvailabilityDialogComponent {

    public contract: Contract;
    public contractItem: ContractItem;

    constructor(public dialog: MatDialogRef<ContractItemAvailabilityDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.contract = data.contract;
        this.contractItem = data.contractItem;
    }

    uniqueContractIds(contracts: AvailabilityContract[]): number[] {
        return contracts.map(c => c.contractId).filter((value, index, self) => self.indexOf(value) === index);
    }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/ContractItemAvailabilityDialogComponent/contract-item-availability.dialog.component.ts